import { useParams } from 'react-router-dom';
import { useSites } from '../hooks/useSites';
import { useModuleData, useUpdateModuleData } from '../hooks/useModuleData';
import { MenuEditor } from '../components/editors/MenuEditor';
import { HoursEditor } from '../components/editors/HoursEditor';
import { GalleryEditor } from '../components/editors/GalleryEditor';
import { HeroEditor } from '../components/editors/HeroEditor';
import { AnnouncementEditor } from '../components/editors/AnnouncementEditor';
import { ServicesEditor } from '../components/editors/ServicesEditor';
import { MODULE_REGISTRY } from '@inboundhost/shared';

export function ModuleEditorPage() {
  const { moduleType } = useParams<{ moduleType: string }>();
  const { data } = useSites();
  const site = data?.sites[0];
  const { data: mod, isLoading } = useModuleData(site?.id, moduleType ?? '');
  const update = useUpdateModuleData(site?.id ?? '', moduleType ?? '');

  if (!site || !moduleType) return <div className="p-8">No site selected.</div>;
  if (isLoading) return <div className="p-8 text-gray-500">Loading…</div>;

  const def = MODULE_REGISTRY[moduleType as keyof typeof MODULE_REGISTRY];
  const value = mod?.data ?? null;

  const editors: Record<string, React.ReactNode> = {
    hero: <HeroEditor value={value as any} onSave={(v) => update.mutate(v)} siteId={site.id} />,
    menu: <MenuEditor value={value as any} onSave={(v) => update.mutate(v)} />,
    hours: <HoursEditor value={value as any} onSave={(v) => update.mutate(v)} />,
    gallery: <GalleryEditor value={value as any} onSave={(v) => update.mutate(v)} siteId={site.id} />,
    announcement: <AnnouncementEditor value={value as any} onSave={(v) => update.mutate(v)} />,
    services: <ServicesEditor value={value as any} onSave={(v) => update.mutate(v)} />,
  };

  return (
    <div className="p-8 max-w-3xl">
      <h1 className="text-2xl font-bold mb-1">{def?.label ?? moduleType}</h1>
      <p className="text-gray-600 mb-6">{def?.description}</p>
      {editors[moduleType] ?? (
        <div className="bg-white rounded shadow p-6 text-gray-500">No editor for this module yet.</div>
      )}
      {update.isSuccess && <p className="mt-3 text-sm text-green-600">Saved</p>}
      {update.error && <p className="mt-3 text-sm text-red-600">{(update.error as Error).message}</p>}
    </div>
  );
}
